$( function() {
	updateHeader();
	setBoxChildren();

	$( '#location-selector' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		var $this = $( this );

		$this.toggleClass( 'active' );

		$( '#locations-filter' ).toggleClass( 'active' );
	} );

	$( '#type-selector' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		var $this = $( this );

		$this.toggleClass( 'active' );

		$( '#types-filter' ).toggleClass( 'active' );
	} );

	$( '#reset' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		$( '.filter' ).removeClass( 'active' );
		$( '.property' ).addClass( 'active' );
		$( this ).addClass( 'active' );

		updateHeader();
		setBoxChildren();
	} );

	$( '.property-type' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		var $this = $( this );

		$( '.property-type' ).removeClass( 'active' );
		$this.addClass( 'active' );
	} );

	$( '.location' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		var $this = $( this );

		$this.toggleClass( 'active' );
	} );

	$( '.filter' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var locations = addFilter( '.location', 'data-location' );
		var propertyTypes = addFilter( '.property-type', 'data-property-type' );

		$.each( properties, function( index, property ) {
			if ( isValidProperty( locations, property.locations ) && isValidProperty( propertyTypes, property.propertyTypes ) ) {
				$( '#property-' + property.id ).addClass( 'active' );
			} else {
				$( '#property-' + property.id ).removeClass( 'active' );
			}
		} );

		$( '#reset' ).removeClass( 'active' );

		updateHeader();
		setBoxChildren();

		$( '.filter-container' ).removeClass( 'active' );
		$( '.filter-toggle' ).removeClass( 'active' );
	} );
} );

function isValidProperty( filters, propertyValues ) {
	if ( filters.length < 1 ) {
		return true;
	}

	var validProperty = false;

	$.each( filters, function( index, value ) {
		if ( $.inArray( value, propertyValues ) !== -1 ) {
			validProperty = true;
			return false;
		}
	} );

	return validProperty;
}

function addFilter( selector, attribute ) {
	var filters = [];

	$( selector ).each( function() {
		var $this = $( this );
		if ( $this.hasClass( 'active' ) ) {
			filters.push( $this.attr( attribute ) );
		}
	} );

	return filters;
}

function updateHeader() {
	var count = $( '.property.active' ).length;

	$( '.num' ).html( count );

	if ( count === 1 ) {
		$( '.num-singular' ).removeClass( 'hidden' );
		$( '.num-plural' ).addClass( 'hidden' );
	} else {
		$( '.num-singular' ).addClass( 'hidden' );
		$( '.num-plural' ).removeClass( 'hidden' );
	}

	var locationsTitle = '';
	$( '.location.active' ).each( function() {
		locationsTitle += $( this ).html() + ', ';
	} );

	locationsTitle = locationsTitle.slice( 0, -2 );

	if ( !$( '.location.active' ).length ) {
		locationsTitle = R.string.allLocations;
	}

	$( '.current-location' ).html( locationsTitle );
}


function setBoxChildren() {
	$( '.property' ).removeClass( 'child-0' ).removeClass( 'child-1' );

	$( '.property.active' ).filter( function( index, element ) {
		return index % 2 == 0;
	} ).addClass( 'child-0' );

	$( '.property.active' ).filter( function( index, element ) {
		return index % 2 == 1;
	} ).addClass( 'child-1' );
}

